'use strict';

var _ = require('lodash');
var TDChartClassGroupsAggregationFactory = function TDChartClassGroupsAggregationFactory(DataAggregationFactory, ExtractMetricKeysService, ClassIndicesService, fcrService) {
  function TDChartClassGroupsAggregation() {
    DataAggregationFactory.call(this, 'market-product-group', 'thematic-demand-chart-market-class-groups');
  }
  TDChartClassGroupsAggregation.prototype = Object.create(DataAggregationFactory.prototype);
  TDChartClassGroupsAggregation.constructor = DataAggregationFactory;
  function getClassGroupIndicesKey(data) {
    var fcrTag = fcrService.getFcrTagForMultipleEntities(data, 'departureDateMoment');
    return data && data.length && data[0].market + (fcrTag.length > 0 ? '-' : '') + fcrTag;
  }
  TDChartClassGroupsAggregation.prototype.sortByClassGroupIndex = function (aggregated, data) {
    var classGroupIndicesKey = getClassGroupIndicesKey(data);
    var indices = ClassIndicesService.prepareClassGroupIndices(classGroupIndicesKey);
    return _.chain(aggregated).map(function (v, k) {
      return _.extend(v, {
        idx: indices[k]
      });
    }).sortBy(['idx', 'label']).map(_.curryRight(_.omit, 2)('idx')).value();
  };
  TDChartClassGroupsAggregation.prototype.aggregate = function (data, metrics) {
    var aggregationFunction = this.getAggregationFunction(metrics);
    var aggregatedClassGroups = {};
    var reducedEntry, metricKeys, keysLength, keys;
    for (var index = 0, dataLength = data.length; index < dataLength; index++) {
      if (Array.isArray(aggregatedClassGroups[data[index].classGroup])) {
        aggregatedClassGroups[data[index].classGroup].push(data[index]);
      } else {
        aggregatedClassGroups[data[index].classGroup] = [data[index]];
      }
    }
    if (Object.keys(aggregatedClassGroups).length > 0) {
      metricKeys = ExtractMetricKeysService.extract(aggregatedClassGroups[Object.keys(aggregatedClassGroups)[0]][0]);
    }
    keys = Object.keys(aggregatedClassGroups);
    for (index = 0, keysLength = keys.length; index < keysLength; index++) {
      reducedEntry = {};
      reducedEntry.label = keys[index];
      aggregationFunction(aggregatedClassGroups[keys[index]], metricKeys, reducedEntry);
      aggregatedClassGroups[keys[index]] = reducedEntry;
    }
    return this.sortByClassGroupIndex(aggregatedClassGroups, data);
  };
  return TDChartClassGroupsAggregation;
};
TDChartClassGroupsAggregationFactory.$inject = ['DataAggregationFactory', 'ExtractMetricKeysService', 'ClassIndicesService', 'FcrService'];
module.exports = TDChartClassGroupsAggregationFactory;